/**
 * The command rail's own surface. The rail is DARK in both themes (board
 * "1 · Command Rail" — it is the layout's signature), which no shared token
 * describes: every value is a `--color-rail-*` theme variable with the board's
 * value as the literal fallback. The fallbacks are dark-on-dark pairs that read
 * in light AND dark (the rail never sits on a light ground), and every text
 * pair passes AA:
 *   text      #B4B4C2 on #15151B  ≈ 8.9:1
 *   active    #FFFFFF on #2A2A35  ≈ 14:1
 * If the platform ever adds the tokens to appTheme.ts / globals.css, the rail
 * picks them up with no change here.
 */
export const R = {
  bg: 'var(--color-rail-bg, #15151B)',
  text: 'var(--color-rail-text, #B4B4C2)',
  active: 'var(--color-rail-active, #2A2A35)',
  activeText: 'var(--color-rail-active-text, #FFFFFF)',
  divider: 'var(--color-rail-divider, rgba(255, 255, 255, 0.10))',
  focus: 'var(--color-rail-focus, #FFFFFF)',
}

/** Hover / focus for rail buttons. `.tw-sh-btn` cannot be used on the rail:
 *  its hover paints the THEME's light surface, which in light theme would put
 *  pale text on a pale chip over the dark rail. */
export const RAIL_CSS = `
.tw-rail-btn{transition:background-color .12s,color .12s}
.tw-rail-btn:hover{background:${R.active}!important;color:${R.activeText}!important}
.tw-rail-btn:focus-visible{outline:2px solid ${R.focus};outline-offset:-2px}
.tw-rail-mark{transition:filter .12s}
.tw-rail-mark:hover{filter:brightness(1.12)}
.tw-rail-mark:focus-visible{outline:2px solid ${R.focus};outline-offset:2px}
.tw-rail-scroll{scrollbar-width:thin;scrollbar-color:${R.active} transparent}
@media (prefers-reduced-motion:reduce){.tw-rail-btn,.tw-rail-mark{transition:none}}
`
